import React from 'react';
import PropTypes from 'prop-types';
import { arrayToMap, DOCUMENT_EXTERNAL_EVENTS } from '../helpers/utils';
import { gae, gaeApp } from '../helpers/Analytics';
import Spinner from '../helpers/Spinner';
import { connect } from 'react-redux';
import {
  setDocumentDataUrl,
  removeDocumentPage,
  setIdCheckDocumentType,
  shareActiveDocumentState
} from '../../redux/actions/rootAction';
import withDocumentCommon from '../helpers/withDocumentCommon';

import {
  prepareIdCheckSteps,
  getIdCheckPossibleDocuments,
  defineIdCheckDocumentTypeFromStatus,
  DOC_TYPE_ID_CHECK
} from '../helpers/utils';
import CrossDevicePopUp from '../common/CrossDevicePopUp';
import { isRequestACrossDeviceDocument } from '../../lib/utils';
import withCrossDeviceDocument from '../helpers/withCrossDeviceDocument';

export default function withIdCheck(WrappedComponent) {
  // noinspection JSPotentiallyInvalidUsageOfThis
  class withIdCheckWrapper extends React.Component {
    constructor(props) {
      super(props);
      this.state = {
        _id: Math.random(),
        cameraIsOnDocType: false,
        showIdCheckOnMobilePopup: false,
        activeStep: 0
      };
    }

    componentDidMount() {
      this.moveToStep(
        !this.props.scanEnded && this.props.startFromFirstPage
          ? 0
          : this.findLastNotReadyStep()
      );
    }

    componentDidUpdate() {
      this.props.checkSignal(DOCUMENT_EXTERNAL_EVENTS.NEXT_STEP, () =>
        this.stepNext()
      );
      this.props.checkSignal(DOCUMENT_EXTERNAL_EVENTS.PREV_STEP, () =>
        this.stepBack()
      );
    }

    onIdCheckOnMobileClosed = () => {
      gaeApp('ID_CHECK_MOBILE_POPUP.CLOSE_POPUP');

      this.setState({
        showIdCheckOnMobilePopup: false
      });
    };

    onIdCheckOnMobileDone = (
      pages,
      documentOptions,
      downloadUrl,
      onApplyExternalDataDone
    ) => {
      setTimeout(
        () =>
          this.applyCrossDeviceDataToDesktopIdCheck(
            pages,
            documentOptions,
            downloadUrl
          ).then(() => {
            gaeApp('ID_CHECK.CROSS_DEVICE_DATA_APPLIED');
            onApplyExternalDataDone();
            this.setState(
              {
                crossDeviceDocumentFinished: true
              },
              () =>
                setTimeout(() => {
                  gaeApp(
                    'ID_CHECK.HIDE_CROSS_DEVICE_POPUP_AND_MOVE_TO_LAST_STEP'
                  );
                  this.setState({
                    showIdCheckOnMobilePopup: false
                  });
                  this.moveToStep(this.findLastNotReadyStep());
                }, 3000)
            );
          }),
        3000
      );
    };

    onIdCheckOnMobileOpen = () => {
      this.setState({
        showIdCheckOnMobilePopup: true
      });
    };

    saveDesktopIdCheckDataToCrossDevice = putUrl => {
      gaeApp(
        'ID_CHECK_MOBILE_POPUP.SAVE_ID_CHECK_LOCAL_DATA_TO_EXTERNAL',
        undefined,
        'START'
      );

      this.props.uploadImagesToCrossDeviceDocumentsStorage(
        arrayToMap(
          this.props.idCheckSteps.filter(s => s.url),
          step => step.id,
          step => step.url
        ),
        putUrl
      );
      gaeApp(
        'ID_CHECK_MOBILE_POPUP.SAVE_ID_CHECK_LOCAL_DATA_TO_EXTERNAL',
        undefined,
        'SUCCESS'
      );
    };

    applyCrossDeviceDataToDesktopIdCheck = async (
      pages,
      documentOptions,
      downloadUrl
    ) => {
      gaeApp('ID_CHECK.APPLY_CROSS_DEVICE_DATA_TO_DESKTOP');

      gae('ID_CHECK', 'SET_DOCUMENT_TYPE', documentOptions?.docType);

      this.props.setIdCheckDocumentType(
        this.props.document.id,
        documentOptions?.docType
      );

      this.props.downloadImagesFromCrossDeviceDocumentsStorage(
        pages,
        this.props.document.id,
        downloadUrl
      );
    };

    findLastNotReadyStep() {
      const find = this.props.idCheckSteps.findIndex(step => !step.passed);
      return find === -1 ? this.props.idCheckSteps.length : find;
    }

    stepBack = () => {
      if (this.state.activeStep > 0) {
        this.moveToStep(this.state.activeStep - 1);
        this.setState({
          cameraIsOnDocType: false
        });
      }
    };

    stepNext = () => {
      if (this.state.activeStep < this.lastStepNumber()) {
        this.canNext() && this.moveToStep(this.state.activeStep + 1);
      } else {
        this.props.onDocumentDone();
      }
    };

    moveToStep = step => {
      this.setState(
        {
          activeStep: step
        },
        this.pushDocumentStateUp
      );
    };

    pushDocumentStateUp = () => {
      this.props.shareActiveDocumentState({
        currentPageIsLast:
          this.state.activeStep === this.props.idCheckSteps.length,
        currentPageIndex: this.state.activeStep,
        currentPageTitle: ''
      });
    };

    lastStepNumber() {
      return this.props.idCheckSteps.length;
    }

    canNext = () => {
      const step = this.props.idCheckSteps[this.state.activeStep];
      return this.state.activeStep < this.lastStepNumber() && step.passed;
    };

    setCameraIsOnDocType = payload => {
      this.setState({ cameraIsOnDocType: payload });
    };

    savePage = (url, actionPage) => {
      gae('ID_CHECK', 'SAVE_PAGE', actionPage + ': ' + url);

      this.props.setDocumentDataUrl(this.props.document.id, actionPage, url);
    };

    render() {
      /*const activeStep =
        this.props.idCheckSteps &&
        this.props.idCheckSteps[this.state.activeStep];
      gae(
        'ID_CHECK',
        'ACTIVE_STEP',
        activeStep
          ? activeStep.stepTitle + ': passed - ' + activeStep.passed
          : 'summary'
      );*/

      return (
        <>
          {window.isDesktop && (
            <CrossDevicePopUp
              templateMode={this.props.templateMode}
              opened={Boolean(this.state.showIdCheckOnMobilePopup)}
              onClose={this.onIdCheckOnMobileClosed}
              onDone={this.onIdCheckOnMobileDone}
              onCrossDeviceCreated={putUrl =>
                this.saveDesktopIdCheckDataToCrossDevice(putUrl)
              }
              recipientRequestId={this.props.recipientRequestId}
              docId={this.props.document.id}
              documentOptions={{
                docType: this.props.idCheckDocumentType
              }}
            />
          )}

          {this.state.loadingExternalData && <Spinner fullScreen />}

          <WrappedComponent
            onIdCheckOnMobileOpen={this.onIdCheckOnMobileOpen}
            cameraIsOnDocType={this.state.cameraIsOnDocType}
            setCameraIsOnDocType={this.setCameraIsOnDocType}
            lastNotReadyStep={this.findLastNotReadyStep()}
            activeStep={this.state.activeStep}
            canDoNextStep={this.canNext()}
            onNextStep={this.stepNext}
            onPrevStep={this.stepBack}
            moveToStep={this.moveToStep}
            savePage={this.savePage}
            {...this.props}
          />
        </>
      );
    }
  }

  const mapStateToProps = (state, ownProps) => {
    const document = ownProps.document || {
      id: 'fake_document',
      attachment: [],
      attributes: {}
    };
    const scannedPages = state.scannedDocuments.get(
      ownProps.requestedDocumentId
    );
    const idCheckStatus = state.documentsStatus.get(
      ownProps.requestedDocumentId
    );
    const idCheckDocumentType =
      document && defineIdCheckDocumentTypeFromStatus(document, idCheckStatus);
    return {
      embedMode: state.embedMode,
      startFromFirstPage: ownProps.startFromFirstPage,
      canSaveDocuments: state.canSaveDocuments,
      templateMode: state.templateMode,
      recipientRequestId: state.recipientRequestId,
      executeOneDocumentOnMobile: isRequestACrossDeviceDocument(
        state.requestStartInfo
      ),
      document: document,
      scannedPages: scannedPages,
      idCheckDocumentType: idCheckDocumentType,
      idCheckSteps:
        (document &&
          prepareIdCheckSteps(document, scannedPages, idCheckStatus)) ||
        [],
      possibleDocuments: getIdCheckPossibleDocuments(document)
    };
  };

  const mapDispatchToProps = dispatch => ({
    shareActiveDocumentState: payload =>
      dispatch(shareActiveDocumentState(DOC_TYPE_ID_CHECK, payload)),
    setIdCheckDocumentType: (documentId, docType) =>
      dispatch(setIdCheckDocumentType(documentId, docType)),
    removeDocumentPage: (documentId, pageId) =>
      dispatch(removeDocumentPage(documentId, pageId)),
    setDocumentDataUrl: (documentId, pageId, dataUrl) =>
      dispatch(setDocumentDataUrl(documentId, pageId, dataUrl))
  });

  withIdCheckWrapper.propTypes = {
    uploadImagesToCrossDeviceDocumentsStorage: PropTypes.func,
    downloadImagesFromCrossDeviceDocumentsStorage: PropTypes.func,
    onDocumentDone: PropTypes.func,
    startFromFirstPage: PropTypes.bool,
    scanEnded: PropTypes.bool,
    shareActiveDocumentState: PropTypes.func,
    checkSignal: PropTypes.func,
    setIdCheckDocumentType: PropTypes.func,
    setDocumentDataUrl: PropTypes.func,
    document: PropTypes.object,
    recipientRequestId: PropTypes.string,
    idCheckDocumentType: PropTypes.string,
    initWebSocket: PropTypes.func,
    subscribeWebSocket: PropTypes.func,
    unSubscribeWebSocket: PropTypes.func,
    startCronJob: PropTypes.func,
    stopCronJob: PropTypes.func,
    idCheckSteps: PropTypes.array,
    templateMode: PropTypes.bool
  };

  return withDocumentCommon(
    withCrossDeviceDocument(
      connect(mapStateToProps, mapDispatchToProps)(withIdCheckWrapper)
    )
  );
}
